/**
 * Expense Policy — option lists the form has to render, and their labels.
 *
 * The values are the strings the API accepts, so a dropdown selection is sent
 * through unchanged. Validation of those values belongs to the backend; this
 * file only supplies the choices and their i18n keys.
 */

/** org_expense_policy.category — v1 is Local Conveyance only. */
export const EXPENSE_CATEGORY = "Local_conveyance";

export const CLAIM_TYPE = {
  RATE_PER_KM: "Rate_Per_Km",
  FIXED_MONTHLY: "Fixed_Monthly",
};

export const MAINTENANCE_FREQUENCY = {
  MONTHLY: "Monthly",
  YEARLY: "Yearly",
};

/**
 * Whether maintenance is capped per financial year rather than per month.
 *
 * Compared case-insensitively on purpose: the policy value is passed through
 * from the API untouched, and this decides both the window key a claim is
 * saved with and how a duplicate is worded. An exact === against "Yearly"
 * would silently fall back to monthly for a tenant whose row reads "YEARLY".
 */
export function isYearlyFrequency(frequency) {
  return String(frequency ?? "").trim().toLowerCase() === "yearly";
}

/**
 * One column, so one dropdown — the level count and each level's approver are
 * both implied by the chosen flow.
 */
export const APPROVAL_FLOW = {
  MANAGER: "Manager",
  FINANCE: "Finance",
  MANAGER_THEN_FINANCE: "Manager_Then_Finance",
  FINANCE_THEN_MANAGER: "Finance_Then_Manager",
};

/** The seven modes, in the order the policy screen lists them. */
export const TRANSPORT_MODES = [
  "Own_Bike",
  "Own_Car",
  "Bus",
  "Metro_Train",
  "Taxi_Car",
  "Taxi_Bike",
  "Taxi_Auto",
];

/** Only these two take a rate; the rest are reimbursed at actuals. */
export function isOwnVehicleMode(mode) {
  return mode === "Own_Bike" || mode === "Own_Car";
}

/* ------------------------------------------------------------ label keys */

export const CLAIM_TYPE_LABEL_KEY = {
  [CLAIM_TYPE.RATE_PER_KM]: "localConveyance.claimTypeRatePerKm",
  [CLAIM_TYPE.FIXED_MONTHLY]: "localConveyance.claimTypeFixedMonthly",
};

export const MAINTENANCE_FREQUENCY_LABEL_KEY = {
  [MAINTENANCE_FREQUENCY.MONTHLY]: "localConveyance.frequencyMonthly",
  [MAINTENANCE_FREQUENCY.YEARLY]: "localConveyance.frequencyYearly",
};

export const APPROVAL_FLOW_LABEL_KEY = {
  [APPROVAL_FLOW.MANAGER]: "localConveyance.flowManager",
  [APPROVAL_FLOW.FINANCE]: "localConveyance.flowFinance",
  [APPROVAL_FLOW.MANAGER_THEN_FINANCE]: "localConveyance.flowManagerThenFinance",
  [APPROVAL_FLOW.FINANCE_THEN_MANAGER]: "localConveyance.flowFinanceThenManager",
};

export const MODE_LABEL_KEY = {
  Own_Bike: "localConveyance.modeOwnBike",
  Own_Car: "localConveyance.modeOwnCar",
  Bus: "localConveyance.modeBus",
  Metro_Train: "localConveyance.modeMetroTrain",
  Taxi_Car: "localConveyance.modeTaxiCar",
  Taxi_Bike: "localConveyance.modeTaxiBike",
  Taxi_Auto: "localConveyance.modeTaxiAuto",
};

/**
 * HR gate for this screen, matching the canonical-role convention already used
 * by announcements and polls: exact "hr" or an "hr "-prefixed variant.
 */
export function isHrRole(roles = []) {
  return roles.some((role) => role === "hr" || role.startsWith("hr "));
}
